import toNumber from 'lodash/toNumber'

/**
 * 숫자를 currency 포맷팅 처리한다.
 * @param val 숫자값
 */
export const formatCurrency = (val: number | string, fixedPoint: number = 0): string => {
  if (val === null || val === undefined) {
    return null
  }

  const convertedVal: number = typeof val === 'string' ? toNumber(val) : (val as number)
  let convertedStr = convertedVal.toFixed(fixedPoint) + (fixedPoint === 0 ? '.' : '')

  convertedStr = convertedStr.replace(/\d(?=(\d{3})+\.)/g, '$&,')

  if (fixedPoint === 0) {
    convertedStr = convertedStr.substring(0, convertedStr.length - 1)
  }

  return convertedStr
}
